import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../../../models/usuarios.service'
import {Fornecedores} from '../../../../../models/fornecedores.model'
import {CarrinhoItemsModel} from '../../../../../models/carrinhoItems.model'
import { QueryFn } from 'angularfire2/firestore';
import { Formatter } from '../../../../../comum/pipes/formatter';
import { Router } from '@angular/router'
import { ReturnStatement } from '../../../../../node_modules/@angular/compiler';


@Component({
  selector: 'app-minhas-vendas-admin',
  templateUrl: './minhas-vendas-admin.component.html',
  styleUrls: ['./minhas-vendas-admin.component.scss']
})
export class MinhasVendasAdminComponent implements OnInit {

  pedidosModel : CarrinhoItemsModel
  colunas = ['fornecedor','data','total','ver_vendas']
  dataSource : Array<any>
  dataDe : Date  
  dataAte : Date 
  fornecedores : Array<any> = []
  codigoFornecedorSelecionado : string = ''
  totalRodape : number = 0
  totalComissaoRodape : number = 0
  constructor(private usersService : UsersService, private router : Router) 
  { 
    this.dataDe = new Date()
    this.dataAte = new Date()
    this.pedidosModel = new CarrinhoItemsModel(this.usersService.usuarioClass.dbConn,this.usersService)
  }

  ngOnInit() {

   
  }

  fornecedorPertenceAoAfiliado()  : boolean {
    let arr = this.fornecedores.filter(elem=> {
     return (elem.codigo == this.codigoFornecedorSelecionado) && 
     (elem.afiliado == this.usersService.usuario.codigo)
    
    })
    return (arr && (arr.length > 0) )

  }

  pesquisar()
  {
   try{
      if(!this.isNumber(this.codigoFornecedorSelecionado)) {
        throw 'Necessário indicar o código do fornecedor.'
      }
      if(this.usersService.isAfiliado){
        if(this.diffDays() > 30){
          throw 'Só é permitido buscar registros no período de 31 dias.'
        }    
        if(!this.fornecedorPertenceAoAfiliado()) { 
          throw 'Só é permitido ver fornecedores pertencentes ao usuário afiliado.'
        }
      }
      this.pedidosModel.pedidoClass.snapshot(this.where(),
      (pedidos)=>{
        if(pedidos && (pedidos.length >=0) )
        {
          this.separarPorData(pedidos)
        }
      }
    ,true)
   } 
   catch(Err){
     alert(Err)
   }   
  }

  diffDays() : number{
    const timeDiff = Math.abs(this.dataDe.getTime() - this.dataAte.getTime())
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
    return diffDays
  }
  separarPorData(pedidos)
  {
      let  arr = pedidos.filter( elem => elem.estado > 0) //chave composta data,fornecedor
      .map( elem => `${new Date(elem.data).toLocaleDateString() }-${elem.fornecedor}` )

      arr = Array.from(new Set(arr)) //remove linhas duplicadas 
      this.totalRodape = 0
      this.totalComissaoRodape = 0
      for(let i = 0 ; i < arr.length ; i++)
      {
         let chaveArr = arr[i].split('-')
         let fornecedor = Number(chaveArr[1])
         let data : string = chaveArr[0]
         let total = this.totalPorDataDoFornecedor(pedidos,fornecedor,data)
         let comissao = this.comissaoFornecedor(fornecedor) || 0
         this.totalRodape += total
         if(comissao > 0)
          this.totalComissaoRodape += ((total * comissao) / 100)
         arr[i] = { data : data,
          fornecedor : this.fornecedorNomePorCodigo(fornecedor) || fornecedor,
           total : Formatter.formatMoney(total) 
          } 
      }
      this.dataSource = arr
  }

  comissaoFornecedor(nFornecedor)
  {
     let arr = this.fornecedores.filter( (elem)=> (elem.codigo == nFornecedor)  )
     if(arr && (arr.length > 0))
       return arr[0].comissao
  }

  total()
  {
    return Formatter.formatMoney(this.totalRodape)
  }
  totalComissao()
  {
    return Formatter.formatMoney(this.totalComissaoRodape)
  }

  totalPorDataDoFornecedor(pedidos : Array<any>,fornecedor : number , data : string ) 
  {
       let pedidosArr =  pedidos.filter((elem)=>{
         let elemData = new Date(elem.data).toLocaleDateString()
         return ( (elem.estado > 0) && (elem.fornecedor == fornecedor) && (elemData == data) )
       })
       let total = 0 
       for(let elem of pedidosArr)
       {
          total += elem.total || elem.valor
       }
       return total 
  }
     
  fornecedorNomePorCodigo(codigo : number) : string
  {
      let arr = this.fornecedores.filter( elem => (elem.codigo == codigo) )
      if(arr && (arr.length > 0))
        return arr[0].nome
  }

  isNumber(txt : string) : boolean{
    return (new RegExp(/^\d+$/).test(txt))
  }

  isEmail(txt : string) : boolean{ //http://emailregex.com/
    return new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(txt)
  }

  onKeyFinish(value : string){
    if(!value) return
    let txt = value.trim()
    let fornecedoresModel = new Fornecedores(this.usersService.usuarioClass.dbConn,false)
    let isWordWithLenBiggerThanTwo = ( (txt.length > 2) && (new RegExp(/\w+/).test(txt)) )
    let where : QueryFn = (e)=> {    
      if(this.isNumber(txt)){
        return e.where('codigo','==',Number(txt))
      }       
      else if(this.isEmail(txt)){
        return e.where('email','==',txt)
      }   
      else if(isWordWithLenBiggerThanTwo) {
        return e.where('nome','==',txt)
      } 
     }          
    if( this.isNumber(txt) || isWordWithLenBiggerThanTwo || this.isEmail(txt)){
      fornecedoresModel.snapshot(where,
        (data)=>{
          this.fornecedores = data   
        },false)
    }
  }

  fmtDate(inputDate : Date )
  {
    return inputDate.toISOString().substring(0, 10)
  }

  where() : QueryFn
  {
    let where : QueryFn 
    if(Number(this.codigoFornecedorSelecionado) == 0)
    {
      where = (elem)=>{
        return elem.where('data', '>=', new Date(`${this.fmtDate(this.dataDe)}T00:00:00.000Z`))
        .where('data', '<=', new Date(`${this.fmtDate(this.dataAte)}T23:59:59.999Z`))
      }
    }
    else 
    { 
      where = (elem)=>{
        return elem.where('data', '>=', new Date(`${this.fmtDate(this.dataDe)}T00:00:00.000Z`))
        .where('data', '<=', new Date(`${this.fmtDate(this.dataAte)}T23:59:59.999Z`))
        .where('fornecedor','==',Number(this.codigoFornecedorSelecionado))
      }
    }   

    return where
  }

  goToVendasDiaria(date : string)
  {
      let arr = date.split('/') 
      this.router.navigate(['minhasVendas','vendasDiaria',
      this.codigoFornecedorSelecionado,`${arr[2]}-${arr[1]}-${arr[0]}`])
  }

}
